module.exports = __webpack_public_path__ + "media/images/new/topo-map-bg-8a57c2cd1754a268d1b8699406815f4f.png";